module.exports = function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/ramdasauce/~/ramda/src/internal/_pipe.js
// module id = 743
// module chunks = 0